import { useQuery } from 'react-query';
import { useAuth } from '../../auth/AuthProvider';
import { getRequestHeaders, vake_api_server_url } from '../helpers';
import { UUID } from 'crypto';

type IncomingReports = {
    reportName: string;
    createdAt: string;
    startTime: string;
    endTime: string | null;
    uuid: UUID;
    reportType: ReportType;
    mmsi: number | null;
    customerGroupName: string | null;
    bucketPath: string | null;
};

export const useGetAllReports = () => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/home/all-reports`;
    return useQuery<AllReports[]>(
        ['all-reports'],
        async () => {
            const res = await fetch(url, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            const incomingReports: IncomingReports[] = await res.json();
            return incomingReports.map((element) => {
                return {
                    ...element,
                    createdAt: new Date(element.createdAt),
                    startTime: new Date(element.startTime),
                    endTime: element.endTime ? new Date(element.endTime) : null,
                };
            });
        },
        {
            staleTime: Infinity,
        }
    );
};
